<template>
  <div class="myinfo">
    <a-spin :spinning="logoutSpinning">
      <div class="form-horizontal">
        <div class="form-group row">
          <label class="col-md-4 control-label">原始密码</label>
          <div class="col-md-8">
            <a-input-password
              type="password"
              class="form-control border"
              v-model="pwd"
              placeholder="请输入原始密码"
              @input="handleOldInput"
            />
            <div v-if="oldPsdMessage">
              <span style="color: red; font-size: 10.4px; font-weight: 700">
                {{ oldPsdMessage }}
              </span>
            </div>
          </div>
        </div>

        <!-- <div class="form-group row">
          <label class="col-md-4 control-label">新密码</label>
          <div class="col-md-8">
            <a-input-password
              type="password"
              class="form-control border"
              @input="handleInput"
              v-model="npwd"
              placeholder="请输入新密码"
              :maxlength="20"
            />
            <div v-if="psdMessage">
              <span style="color: red; font-size: 10.4px; font-weight: 700">
                {{ psdMessage }}
              </span>
            </div>
          </div>
        </div> -->

        <div class="form-group row">
          <label class="col-md-4 control-label">新密码</label>
          <div class="col-md-8">
            <a-input-password
              type="password"
              class="form-control border"
              @input="checkPasswordStrength"
              v-model="npwd"
              placeholder="请输入新密码"
            />
            <div class="password-feedback">
              <div
                class="strength-bar"
                :style="{
                  width: strengthPercentage + '%',
                  backgroundColor: strengthColor,
                }"
              ></div>
              <div>
                <span :style="{ color: strengthColor }">
                  {{ strengthText }}
                  <a-icon
                    v-if="npwd.length >= 8 && strengthLevel >= 2"
                    type="check-circle"
                    theme="filled"
                    :style="{ color: '#52c41a' }"
                  />
                </span>
                <span
                  v-if="psdMessage"
                  style="color: red; font-size: 10.4px; font-weight: 700"
                >
                  {{ psdMessage }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 control-label">密码确认</label>
          <div class="col-md-8">
            <a-input-password
              type="password"
              class="form-control border"
              @input="handleInputCheck"
              v-model="npwd_again"
              placeholder="请再次输入新密码"
            />
            <div v-if="psdAgain">
              <span style="color: red; font-size: 10.4px; font-weight: 700">
                {{ psdAgain }}
              </span>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-4 control-label">&nbsp;&nbsp;&nbsp;&nbsp;</label>
          <div class="col-md-8">
            <button
              type="submit"
              v-if="isLogOut"
              class="btn btn-default"
              style="width: 90px"
              @click="exit"
            >
              退出登录
            </button>
            <button type="submit" class="btn btn-default" @click="submit">
              提交
            </button>
          </div>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import JsEncrypt from "jsencrypt";
import { mapState } from "vuex"; //引入JsEncrypt用于加密密码，避免明文传输带来的风险
export default {
  name: "ForgetPassword",
  props: {
    arrs: Array,
  },
  data: function () {
    return {
      pwd: "", // 旧密码
      npwd: "", // 新密码
      npwd_again: "", // 确认新密码
      publicKey: null, // 用于加密密码的key
      uuid: null, // 用于向后台确认加密key的id
      isLogOut: false,
      logoutSpinning: false,
      psdMessage: "",
      psdAgain: "",
      oldPsdMessage: "",
      strengthLevel: 0, // 0: 弱, 1: 中, 2: 强
      strengthText: "",
      strengthColor: "#ff4d4f", // 默认红色
      strengthPercentage: 0,
    };
  },
  created() {
    this.axios.get(`/sys/login/token`).then((res) => {
      this.publicKey = res.result.publicKey;
      this.uuid = res.result.uuid;
    });
    this.compelUpPass();
  },
  computed: {
    page_arrs() {
      let { currentPage, pagesize } = this;
      return this.arrs.slice(
        (currentPage - 1) * pagesize,
        currentPage * pagesize
      );
    },
    current_page() {
      return this.currentPage;
    },
    ...mapState(["userInfo"]),
  },
  methods: {
    checkPasswordStrength() {
      //原校验
      /*  // 清除旧消息
      this.psdMessage = "";

      // 空密码处理
      if (!this.npwd) {
        this.resetStrengthIndicator();
        return;
      }

      // 长度检查
      if (this.npwd.length < 8) {
        this.setStrengthIndicator(0, "弱", "#ff4d4f", 33);
        this.psdMessage = "密码至少8位,需由数字、大小写字母和特殊符号组成!";
        return;
      }

      if (this.npwd.length > 20) {
        this.npwd = this.npwd.slice(0, 20);
        this.psdMessage = "密码不超过20位需由数字、大小写字母和特殊符号组成!";
        return;
      }

      // 密码强度计算
      let strength = 0;

      // 长度得分
      if (this.npwd.length >= 8) strength += 1;
      if (this.npwd.length >= 12) strength += 1;

      // 包含数字
      if (/\d/.test(this.npwd)) strength += 1;

      // 包含小写字母
      if (/[a-z]/.test(this.npwd)) strength += 1;

      // 包含大写字母
      if (/[A-Z]/.test(this.npwd)) strength += 1;

      // 包含特殊字符
      if (/[^a-zA-Z0-9]/.test(this.npwd)) strength += 2;

      // 设置强度指示器
      if (strength < 3) {
        this.setStrengthIndicator(0, "弱", "#ff4d4f", 33);
      } else if (strength < 6) {
        this.setStrengthIndicator(1, "中", "#faad14", 66);
      } else {
        this.setStrengthIndicator(2, "强", "#52c41a", 100);
      } */

       //新校验
      // 清除旧消息
      this.psdMessage = "";
      this.passwordStatus = "";
      //删除密码的空格
      this.npwd = this.npwd.replace(/\s+/g, '')
      // 空密码处理
      if (!this.npwd) {
        this.resetStrengthIndicator();
        return;
      }

      // 长度检查
      if (this.npwd.length < 8) {
        this.setStrengthIndicator(0, "弱", "#ff4d4f", 33);
        this.psdMessage = "密码要求:8-20位,需包含大小写字母、数字及特殊符号(如!@#),避免简单组合。";
        return;
      }

      if (this.npwd.length > 20) {
        this.npwd = this.npwd.slice(0, 20);
        this.psdMessage = "密码要求:8-20位,需包含大小写字母、数字及特殊符号(如!@#),避免简单组合。";
        return;
      }

      // 检查包含的字符类型
      const hasNumber = /\d/.test(this.npwd);
      const hasLower = /[a-z]/.test(this.npwd);
      const hasUpper = /[A-Z]/.test(this.npwd);
      const hasSpecial = /[^a-zA-Z0-9]/.test(this.npwd);

      // 计算满足的类型数量
      const typeCount = [hasNumber, hasLower, hasUpper, hasSpecial].filter(
        Boolean
      ).length;

      // 设置强度等级
      if (typeCount === 4) {
        // 强密码：包含全部4种类型
        this.setStrengthIndicator(2, "强", "#52c41a", 100);
        this.psdMessage = "";
      } else if (typeCount >= 2) {
        // 中密码：包含2-3种类型
        this.setStrengthIndicator(1, "中", "#faad14", 66);
        this.psdMessage = "密码要求:8-20位,需包含大小写字母、数字及特殊符号(如!@#),避免简单组合。";
      } else {
        // 弱密码：只包含1种或0种类型
        this.setStrengthIndicator(0, "弱", "#ff4d4f", 33);
        this.psdMessage = "密码要求:8-20位,需包含大小写字母、数字及特殊符号(如!@#),避免简单组合。";
      }
    },

    resetStrengthIndicator() {
      this.strengthLevel = 0;
      this.strengthText = "";
      this.strengthColor = "#ff4d4f";
      this.strengthPercentage = 0;
    },
    setStrengthIndicator(level, text, color, percentage) {
      this.strengthLevel = level;
      this.strengthText = text;
      this.strengthColor = color;
      this.strengthPercentage = percentage;
    },
    handleOldInput(e) {
      if (e.target.value && e.target.value.length > 20) {
        this.pwd = e.target.value.slice(0, 20);
        this.oldPsdMessage = "密码要求:8-20位,需包含大小写字母、数字及特殊符号(如!@#),避免简单组合。"
      } else {
        this.oldPsdMessage = "";
      }

      //原密码数据库是否校验
    },

    handleInput(e) {
      // let reg =
      //   /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9])).{8,20}$/;
      // if (!reg.test(e.target.value)) {
      //   this.psdMessage =
      //     "密码至少8位，不超过20位需由数字、大小写字母和特殊符号组成!";
      //   if (!e.target.value) {
      //     this.psdMessage = "";
      //   }
      // } else {
      //   this.psdMessage = "";
      // }
    },

    handleInputCheck(e) {
      if (this.npwd !== e.target.value) {
        this.psdAgain = "两次输入密码不一致！";
        if (!e.target.value) {
          this.psdAgain = "";
        }
      } else {
        this.psdAgain = "";
      }
    },
    compelUpPass() {
      let weakPassword = JSON.parse(localStorage.getItem("WEAK_PASSWORD"));
      if (weakPassword) {
        this.isLogOut = true;
      }
    },
    exit() {
      this.logoutSpinning = true;

      this.axios.get(`sys/logout`).then((res) => {
        if (res.success) {
          this.$message.success(res.result, 1);
        }
        localStorage.clear();
        setTimeout(() => {
          this.common.toURL(`/login?id=${this.userInfo.eduCode}`);
          this.logoutSpinning = false;
        }, 1000);
      });
    },
    primaryPage() {
      this.currentPage = 1;
      this.activenum = 0;
    },
    submit() {
      if (!this.pwd) {
        this.$message.warning("请输入原始密码!");
        return;
      }
      if (!this.npwd) {
        this.$message.warning("请输入新密码!");
        return;
      }
      // var myreg =
      //   /^(?:(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9])).{8,20}$/;
      // if (!myreg.test(this.npwd)) {
      //   this.$message.warning(
      //     "新密码至少8位，不超过20位需由数字、大小写字母和特殊符号组成"
      //   );
      //   return;
      // }
      // if (!this.npwd_again) {
      //   this.$message.warning("请再次输入新密码!");
      //   return;
      // }

      if (this.strengthLevel !== 2) {
        this.$message.warning("密码要求:8-20位,需包含大小写字母、数字及特殊符号(如!@#),避免简单组合。");
        return;
      }

      if (this.npwd_again === this.npwd) {
        if (this.npwd !== this.pwd) {
          const jse = new JsEncrypt();
          let psw = {
            oldPsw: null,
            newPsw: null,
            uuid: this.uuid,
          };
          jse.setPublicKey(this.publicKey);
          psw.oldPsw = jse.encrypt(this.pwd);
          psw.newPsw = jse.encrypt(this.npwd);
          this.axios
            .post(`/biz/user/password/modify`, psw)
            .then((res) => {
              this.$message.success("修改成功");
              setTimeout(() => {
                this.axios.get(`sys/logout`).then((res) => {
                  if (!res) {
                    // this.$message.error("未查询到登录信息", 1);
                  } else {
                    this.$message.success("请重新登录", 1);
                  }
                  localStorage.clear();
                  setTimeout(() => {
                    this.common.toURL("/login");
                    // this.$router.replace('/login')
                  }, 1000);
                });
              }, 500);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.$message.warning("旧密码不可与新密码一致！");
        }
      } else {
        this.$message.warning("两次输入的密码不一致，请重新输入！");
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.password-feedback {
}

.strength-bar {
  height: 3px;
  background: #f0f0f0;
  margin-bottom: 4px;
  border-radius: 2px;
  transition: all 0.3s;
}

/* 确保图标与文字对齐 */
.password-feedback .anticon {
  margin-left: 4px;
}

.btn-style {
  background: $bgColor;
  padding: 2px 12px;
  color: #fff;
}

.border-none {
  border: 0;
}

input {
  border: 1px solid #f2f2f2;
}

.myinfo {
  .row {
    width: 500px;
    margin: 0 auto;
  }

  background: #f6fffb;
  padding: 28px;
  margin-left: 20px;
  margin-right: 28px;

  .col-md-4 {
    padding-right: 0;
  }

  label {
    margin-top: 10px;
    color: #999;
  }

  h1 {
    border-bottom: 1px solid #efefef;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .btn {
    background: $bgColor;
    color: #fff;
    width: 80px;
  }

  .form-group {
    margin-bottom: 20px;
  }
}

@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.border-none {
  border: 0;
}

input {
  border: 1px solid #f2f2f2;
}

.myinfo {
  .row {
    width: 500px;
    margin: 0 auto;
  }

  background: #f6fffb;
  padding: 28px;
  margin-left: 20px;
  margin-right: 28px;

  .col-md-4 {
    padding-right: 0;
  }

  label {
    margin-top: 10px;
    color: #999;
  }

  h1 {
    border-bottom: 1px solid #efefef;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .btn {
    background: $bgColor;
    color: #fff;
    width: 80px;
  }

  .form-group {
    margin-bottom: 20px;
  }
}

@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.border-none {
  border: 0;
}

input {
  border: 1px solid #f2f2f2;
}

.myinfo {
  .row {
    width: 500px;
    margin: 0 auto;
  }

  background: $bgcontent;
  padding: 28px;
  margin-left: 20px;
  margin-right: 28px;

  .col-md-4 {
    padding-right: 0;
  }

  .form-horizontal {
    background: #fff;
    padding: 28px;
  }

  label {
    margin-top: 10px;
    color: #999;
  }

  h1 {
    border-bottom: 1px solid #efefef;
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .btn {
    background: $bgColor;
    color: #fff;
    width: 80px;
  }

  .form-group {
    margin-bottom: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/PersonalCenters/components/ForgetPassword.vue